import { JsonObject, JsonProperty } from 'json2typescript';

import { FiscalCountry } from './fiscal-country';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TaxInterface } from '../../../core';

@JsonObject('Tax')
export class Tax implements TaxInterface {
    @JsonProperty('IsUSPersonFiscalPurposes', Boolean, true)
    private _isUSPersonFiscal: boolean = undefined;

    @JsonProperty('TINNumber', StringAdapter, true)
    private _TINNumber: string = undefined;

    @JsonProperty('IsOtherCountryPersonFiscalPurposes', Boolean, true)
    private _isOtherCountryPersonFiscal: boolean = undefined;

    @JsonProperty('FiscalPurposesCountries', [FiscalCountry], true)
    private _fiscalCountries: FiscalCountry[] = undefined;

    get isUSPersonFiscal(): boolean {
        return this._isUSPersonFiscal;
    }

    set isUSPersonFiscal(value: boolean) {
        this._isUSPersonFiscal = value;

        if (this._isUSPersonFiscal) {
            this._isOtherCountryPersonFiscal = false;
            this._fiscalCountries = [];
        } else {
            this._TINNumber = undefined;
        }
    }

    get TINNumber(): string {
        return this._TINNumber;
    }

    set TINNumber(value: string) {
        this._TINNumber = value;
    }

    get isOtherCountryPersonFiscal(): boolean {
        return this._isOtherCountryPersonFiscal;
    }

    set isOtherCountryPersonFiscal(value: boolean) {
        this._isOtherCountryPersonFiscal = value;

        if (this._isOtherCountryPersonFiscal) {
            this._isUSPersonFiscal = false;
            this._TINNumber = undefined;
        } else {
            this._fiscalCountries = [];
        }
    }

    get fiscalCountries(): FiscalCountry[] {
        if (!this._fiscalCountries) {
            this._fiscalCountries = [];
        }

        return this._fiscalCountries;
    }

    addFiscalCountry(value: FiscalCountry) {
        if (!this.fiscalCountries.find((it) => it.name === value.name)) {
            this.fiscalCountries.push(value);
        }
    }

    updateFiscalCountry(value: FiscalCountry) {
        this.fiscalCountries.map((it, idx) => {
            if (it.name === value.name) {
                this.fiscalCountries[idx] = value;
            }
        });
    }

    removeFiscalCountry(value: FiscalCountry) {
        this.fiscalCountries.map((it, idx) => {
            if (it.name === value.name) {
                this.fiscalCountries.splice(idx, 1);
            }
        });
    }

    isComplete(): boolean {
        return (
            (this.isUSPersonFiscal ? !!this.TINNumber : typeof this.isUSPersonFiscal === 'boolean') &&
            (this.isOtherCountryPersonFiscal
                ? this.fiscalCountries.length > 0 && !this.fiscalCountries.some((fiscalCountry) => !fiscalCountry.isComplete())
                : typeof this.isOtherCountryPersonFiscal === 'boolean')
        );
    }
}
